export default __webpack_public_path__ + "static/media/kuis.72ab27ea.svg";